// extracted by mini-css-extract-plugin
module.exports = {"theme-based":"_2aNji","themeBased":"_2aNji"};